import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencil3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPencil3"><Path fillRule="evenodd" clipRule="evenodd" d="M14.543 3.54266C16.1761 1.90977 18.8239 1.90977 20.457 3.54266C22.0901 5.17576 22.09 7.82354 20.457 9.45673L9.48633 20.4284L2.25781 21.7429L3.57227 14.5143L14.543 3.54266ZM13.0859 9.50067L14.5 10.9147L18.6641 6.75067L17.25 5.33661L13.0859 9.50067Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPencil3;
